/*global google*/
import React from 'react';
import { connect } from 'react-redux';
import { updateData } from "../actions";
import ControlService from '../../helper/controlservice';
import Geosuggest from 'react-geosuggest';
import Script from 'react-load-script'
import { settings } from '../../config/settings';

const mapStateToProps = state => ({
    data: state.formDataReducer,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading,
});
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey))
    };
}
class GooglePlaces extends React.PureComponent {
    state = {
        googleModal: false,
        googleEditModal: false,
        googleFilterModal: false,
        googleChildModal: false,
        touched: false,
        mapsjsCoreLoaded: false,
        value: ""
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        var nextData = nextProps.data[nextProps.formid] ? nextProps.data[nextProps.formid][nextProps.control.key] : "";
        if (nextData != prevState.value) {
            return {
                value: nextData
            }
        } else return null;

    }
    componentDidMount() {
        this.controlVaildationCheck(this.props);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.value != this.state.value) {
            this.controlVaildationCheck(this.props);
        }
    }
    controlVaildationCheck(props) {
        const { control, formid, data } = props;
        var _data = data[formid] ? data[formid][control.key] : null
        var _dataValidation = data[formid + "_validation"] && data[formid + "_validation"][control.key] ? data[formid + "_validation"][control.key] : {}
        var validation = ControlService().validate(control, _data);
        if (validation) {
            if (_dataValidation.status != 'pass') {
                this.props.update(control.key, { "status": "pass", "control": control, touched: false }, this.props.formid + "_validation")
            }
        } else if (_dataValidation.status != 'fail') {
            this.props.update(control.key, { "status": "fail", "control": control, touched: false }, this.props.formid + "_validation")
        }
    }
    handleBlur = () => {
        this.setState({
            touched: true,
        });
    }

    shouldMarkError(control, data) {
        const validate = ControlService().validate(control, data[control.key]);

        const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
        const isTouchedOutside = validation ? validation.touched : false;
        const shouldShow = this.state.touched || isTouchedOutside;
        return validate ? !validate : shouldShow;
    }
    onSuggestSelect(suggest, control, action) {
        
        //const { control, action } = this.props;

        this.props.update(control.key, suggest ? suggest.gmaps.formatted_address : "", this.props.formid)

        if (control.StoreJsonnode) {
            var result = {
                "street_number": "",
                "street": "",
                "city": "",
                "state": "",
                "district": "",
                "country": "",
                "postal_code": "",
                "lat": suggest ? suggest.location.lat : '',
                "lng": suggest ? suggest.location.lng : '',
                "adr_address": suggest ? suggest.gmaps.formatted_address : '',
                "name": suggest ? suggest.gmaps.name : '',
                "place_id": suggest ? suggest.placeId : '',
                "types": suggest ? suggest.gmaps.types : '',
                "url": "",
                "utc_offset": suggest ? suggest.gmaps.utc_offset : '',
                "vicinity": "",
                "photos": suggest ? suggest.gmaps.photos : '',
                "airport": "",
                "CountryCodes": "",
                "formatted_address": suggest ? suggest.gmaps.formatted_address : ''
            }
            this.props.update(control.key + "_node", result, this.props.formid)
        }
    }
    handleScriptLoad() {
        this.setState({ mapsjsCoreLoaded: true });
    }
    render() {
        const { control, action, formid } = this.props;
        var data = this.props.data[formid] ? this.props.data[formid] : {};
        const shouldMarkError = this.shouldMarkError(control, data);

        return (
            
            <div className="form-group">
                <Script
                        url={"https://maps.googleapis.com/maps/api/js?key=" + settings.Google.apikey + "&libraries=places"}
                        onLoad={() => this.handleScriptLoad()}
                    >
                    </Script>
                {control.label &&
                    <label htmlFor={control.id}>{control.label}
                        {control.require &&
                            <sup className="text-danger font-weight-bold">*</sup>
                        }
                        {control.showhelptext &&
                            <span className={"custom-tooltip"}>
                                <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                            </span>
                        }
                    </label>
                }
                {control.imageurl &&
                    <img width="100" height="100" alt={control.label} src="control.imageurl" className="mb-2 img-fluid" />
                }
                <div className="input-group">
                    <div className="input-group-prepend">
                        <span className="input-group-text"><i className="fa fa-map-marker"></i></span>
                    </div>
                    {this.state.mapsjsCoreLoaded ?
                        <Geosuggest id="autocomplete" inputClassName={'form-control validate filter-input ' + (shouldMarkError ? "border-danger" : "")}
                            ref={el => this.autocomplete = el}
                            placeholder={control.placeholder}
                            initialValue={this.state.value}
                            onBlur={() => this.handleBlur()}
                            onSuggestSelect={(e) => this.onSuggestSelect(e, control, action)}
                            location={new google.maps.LatLng(53.558572, 9.9278215)}
                            radius="20"
                            disabled={this.props.disabled}
                             />
                    :
                    <div className='form-control'>Please Check your Google API Key</div>
                    }
                </div>
                {shouldMarkError &&
                    <small className="form-text text-danger">
                        {control.errormsg ? control.errormsg : 'You must enter a ' + control.label + '.'}
                    </small>
                }
            </div>
        );
    }
}

export default connect(
    mapStateToProps, bindAction
)(GooglePlaces);